import styled from "styled-components";
import React from "react";

export const Container = styled.div`
  background: ${props => props.background};
  height: 100vh;
  width: 100vw;
  font-family: Helvetica Neue, serif;
  overflow-x: hidden;
`;

export const Header = styled.header`
  display: flex;
  overflow: hidden;
  background-image: url("/plataforma/img/img_background.png");
  background-size: cover;
  background-repeat: no-repeat;
  height: 100vh;
  width: 100vw;
`;

export const ContainerNavBar = styled.div`
  position: fixed;
  z-index: 50000;
  display: flex;
  justify-items: center;
  align-items: center;
  opacity: ${props => (props.status > 400 ? "1" : "0.7")};
  background: ${props => (props.status > 400 ? "#2d2d2d" : "#24566f")};
  height: 50px;
  width: 100%;
`;

export const LogoNavBar = styled.nav`
  position: fixed;
  z-index: 50000;
  display: flex;
  justify-content: space-between;
  justify-items: center;
  align-items: center;
  height: 50px;
  width: 100%;
  border-bottom: 2px solid #00486f;
  img {
    margin-left: 80px;
    margin-right: 20px;
  }
`;

export const NavBarHome = styled.nav`
  position: fixed;
  z-index: 50000;
  display: flex;
  justify-content: space-between;
  justify-items: center;
  align-items: center;
  height: 50px;
  width: 100%;
  border-bottom: 2px solid #000000;
  img {
    margin-left: 80px;
  }
`;

export const WrapperUl = styled.ul`
  align-items: center;
  list-style-type: none;
  display: flex;
  font-family: Helvetica Neue, serif;
  font-size: 0.8em;
  margin-right: 80px;
  justify-content: space-around;
  a:link {
    color: white;
    text-decoration: none;
  }
  a {
    color: white;
  }
`;

export const NavLi = styled.li`
  color: white;
  margin: 5px;
  font-size: 12px;
  padding-left: 10px;
  padding-right: 10px;
  background: ${props => props.background};
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  justify-items: center;
  height: 50px;
  cursor: pointer;

  &:hover {
    background: #031a2e;
    a {
      transition: 0.1s;
    }
  }
`;

export const FraseHome = styled.div`
  color: white;
  display: flex;
  width: 80%;
  flex-direction: column;
  justify-content: center;
  justify-items: center;

  div {
    font-size: 3em;
    text-shadow: 1px 0.5px 0.2em rgba(0, 0, 0, 0.83);
  }
  p {
    font-size: 22px;
    margin-top: 10px;
  }
`;

export const WrapperHome = styled.article`
  margin-top: 7.5vh;
  padding: 80px;
  width: 100%;
  display: flex;
`;

export const Icones = styled.div`
  color: white;
  opacity: 0.8;
  width: 20%;
  display: flex;
  text-align: center;
  flex-direction: column;
  justify-content: end;
  align-items: flex-end;
  justify-items: center;
  div {
    text-align: center;
  }
`;

export const WrapperIcone = styled.div`
  text-align: center;
  margin-top: 50px;
  color: #37cfe3;
  div {
    font-size: 25px;
    margin-left: 15px;
    color: white;
  }
  span {
    font-size: 11px;
    margin: 2px;
    color: white;
  }
`;
